module.exports = __webpack_public_path__ + "media/brands/elddis-64fa7c86.png";